import { MeterTypeService } from '@/http-services/meter-type.service';
import { UtilityFamily } from '@ncss/models/dist/v3';
import { until, useAsyncState } from '@vueuse/core';
import { computed, watch } from 'vue';

export function useMeterManufacturers(getUtility: () => UtilityFamily | undefined | null) {
  const meterTypes = new MeterTypeService();
  const utilityFamily = computed(getUtility);

  const {
    state: all,
    isLoading,
    isReady,
    execute: refresh,
  } = useAsyncState(async () => {
    const family = utilityFamily.value;
    if (family !== undefined && family !== null) {
      const docs = await meterTypes.getManufacturers(family);
      return docs;
    }
    return [];
  }, []);

  async function search(text?: string) {
    await until(isReady).toBe(true);
    if (text) {
      return all.value?.filter((m) => m.name?.toLowerCase()?.includes(text.toLowerCase()));
    } else {
      return all.value;
    }
  }

  async function findById(id: number) {
    await until(isReady).toBe(true);
    return all.value?.find((m) => m._id === id);
  }

  watch(utilityFamily, () => refresh(), { immediate: true });
  return { all, isLoading, isReady, search, findById };
}
